import { $http } from '@tajawal/web-core-sdk-v2/lib/services/http.service';
import { ENDPOINTS, LANGUAGE } from "../constants/index.js";
/**
 * google translation client
 */
export var GoogleTranslationClient = {
  /**
   * translate
   * @param {string} string
   * @param {string} targetLanguage
   * @returns {Promise}
   */
  translate: function translate(_ref) {
    var string = _ref.string,
      _ref$targetLanguage = _ref.targetLanguage,
      targetLanguage = _ref$targetLanguage === void 0 ? LANGUAGE.AR : _ref$targetLanguage;
    var requestId = "GOOGLE_TRANSLATION_" + string;
    var endPoint = ENDPOINTS.GOOGLE_TRANSLATION;
    return $http.post(requestId, endPoint, {
      data: {
        remarks: string,
        targetLanguage: targetLanguage
      }
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  }
};